import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBInput,
  MDBSwitch,
  MDBIcon,
} from "mdb-react-ui-kit";

import { MfmImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmImageUploader/MfmImageUploader";
import { mfmMediumUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";
import { PopConfirm } from "Projects/CC_cubi_clan_project/GlobalComponents/PopConfirm/PopConfirm";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import RichTextEditor from "Projects/CC_cubi_clan_project/GlobalComponents/RichTextEditor/RichTextEditor";

import "./AdminNewsDetail.css";

const stripDataUrl = (dataUri) =>
  dataUri && String(dataUri).startsWith("data:image")
    ? String(dataUri).replace(/^data:image\/[a-zA-Z0-9+.-]+;base64,/, "")
    : dataUri || "";

const toDataUri = (b64) => (b64 ? `data:image/jpeg;base64,${b64}` : "");

export default class AdminNewsDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noticia: null,
      loading: true,
      isNew: false,
      showDeleteConfirm: false,
    };
  }

  componentDidMount() {
    const slug = this.getSlugFromUrl();
    if (slug && slug !== "nueva") {
      this.loadNoticia(slug);
    } else if (slug === "nueva") {
      this.handleNewNoticia();
    } else {
      this.setState({ loading: false });
    }
  }

  getSlugFromUrl() {
    const path = window.location.pathname;
    const match = path.match(/\/noticia\/([^/]+)$/);
    return match ? match[1] : null;
  }

  async loadNoticia(slug) {
    this.setState({ loading: true });
    if (this.props.onLoading) this.props.onLoading(true);
    try {
      const response = await doFetch(
        "MUGIN",
        "getNoticia?slug=" + encodeURIComponent(slug),
        { method: "GET" }
      );
      const data = await response.json();
      if (data && data.STATE === "SUCCESS" && data.DATA) {
        this.setState({ noticia: data.DATA, isNew: false });
      } else {
        this.setState({ noticia: null, isNew: false });
      }
    } catch (error) {
      console.error("Error al cargar noticia:", error);
      this.setState({ noticia: null });
    } finally {
      this.setState({ loading: false });
      if (this.props.onLoading) this.props.onLoading(false);
    }
  }

  updateField = (field, value) => {
    this.setState((prev) => ({
      noticia: { ...prev.noticia, [field]: value },
    }));
  };

  handleNewNoticia = () => {
    this.setState({
      noticia: {
        IDNoticia: null,
        slug: null,
        titulo: "",
        texto: "",
        textoCorto: "",
        base64img: null,
        imageUuid: null,
        fecha: new Date().toISOString().split("T")[0],
        link: "",
        sortOrder: 0,
        active: 1,
      },
      isNew: true,
      loading: false,
    });
  };

  handleSave = async () => {
    const { noticia } = this.state;
    if (!noticia) return;

    if (!noticia.titulo || noticia.titulo.trim() === "") {
      toast.show({
        message: "El título es obligatorio",
        type: "warning",
        position: "bottom-center",
        size: "wide",
        animation: "slide",
        timeout: 3000,
      });
      return;
    }

    this.setState({ loading: true });
    if (this.props.onLoading) this.props.onLoading(true);

    try {
      const payload = {
        IDNoticia: noticia.IDNoticia ?? noticia.iDNoticia ?? null,
        slug: noticia.slug ?? null,
        titulo: noticia.titulo,
        texto: noticia.texto ?? "",
        textoCorto: noticia.textoCorto ?? "",
        base64img: null,
        imageUuid: noticia.imageUuid ?? null,
        fecha: noticia.fecha,
        link: noticia.link ?? "",
        sortOrder: noticia.sortOrder ?? 0,
        active: noticia.active != null ? (noticia.active ? 1 : 0) : 1,
      };

      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      };

      const response = await doFetch("MUGIN", "upsertNoticia", requestOptions);
      const data = await response.json();

      if (data && data.STATE === "SUCCESS") {
        const saved = data.DATA;
        this.setState({ noticia: saved, isNew: false });

        // Update the URL to reflect the slug if it was a new noticia
        if (saved.slug && this.props.onHandleNavLinks) {
          window.history.replaceState(null, "", "/noticia/" + saved.slug);
        }

        toast.show({
          message: "Noticia guardada correctamente",
          type: "success",
          position: "bottom-center",
          size: "wide",
          animation: "slide",
          timeout: 3000,
        });
      } else {
        toast.show({
          message: "Error al guardar: " + (data?.MESSAGE || "desconocido"),
          type: "danger",
          position: "bottom-center",
          size: "wide",
          animation: "slide",
          timeout: 3000,
        });
      }
    } catch (error) {
      console.error("Error al guardar noticia:", error);
      toast.show({
        message: "Error no controlado al guardar la noticia",
        type: "danger",
        position: "bottom-center",
        size: "wide",
        animation: "slide",
        timeout: 3000,
      });
    } finally {
      this.setState({ loading: false });
      if (this.props.onLoading) this.props.onLoading(false);
    }
  };

  handleDelete = async () => {
    const { noticia } = this.state;
    const id = noticia?.IDNoticia ?? noticia?.iDNoticia;
    if (!id) return;

    this.setState({ loading: true });
    if (this.props.onLoading) this.props.onLoading(true);

    try {
      const response = await doFetch(
        "MUGIN",
        "deleteNoticia?IDNoticia=" + id,
        { method: "DELETE" }
      );
      const data = await response.json();

      if (data && data.STATE === "SUCCESS") {
        toast.show({
          message: "Noticia eliminada",
          type: "success",
          position: "bottom-center",
          size: "wide",
          animation: "slide",
          timeout: 3000,
        });
        // Navigate back to Home
        if (this.props.onHandleNavLinks) {
          this.props.onHandleNavLinks({ force: "Home" }, "/");
        }
      } else {
        toast.show({
          message: "Error al eliminar: " + (data?.MESSAGE || "desconocido"),
          type: "danger",
          position: "bottom-center",
          size: "wide",
          animation: "slide",
          timeout: 3000,
        });
      }
    } catch (error) {
      console.error("Error al eliminar noticia:", error);
    } finally {
      this.setState({ loading: false, showDeleteConfirm: false });
      if (this.props.onLoading) this.props.onLoading(false);
    }
  };

  onBack = () => {
    if (this.props.onHandleNavLinks) {
      this.props.onHandleNavLinks({ force: "Home" }, "/");
    }
  };

  getImageForUploader() {
    const { noticia } = this.state;
    if (!noticia || !noticia.base64img) return "";
    const raw = noticia.base64img;
    if (String(raw).startsWith("data:")) return raw;
    return toDataUri(raw);
  }

  isActive() {
    const { noticia } = this.state;
    if (!noticia) return false;
    return (
      noticia.active === 1 ||
      noticia.active === "1" ||
      noticia.active === true
    );
  }

  render() {
    const { noticia, loading, isNew, showDeleteConfirm } = this.state;

    if (loading) return null;

    if (!noticia) {
      return (
        <div className="admin-news-detail">
          <button className="back-link" onClick={this.onBack}>
            ← Volver
          </button>
          <div className="text-center my-5">
            <h3>Noticia no encontrada</h3>
            <p className="text-muted">
              La noticia no existe o ha sido eliminada.
            </p>
            <MDBBtn onClick={this.handleNewNoticia}>
              <MDBIcon icon="plus" className="me-2" />
              Crear nueva noticia
            </MDBBtn>
          </div>
        </div>
      );
    }

    const noticiaId = noticia.IDNoticia ?? noticia.iDNoticia;

    return (
      <div className="admin-news-detail">
        <button className="back-link" onClick={this.onBack}>
          ← Volver
        </button>

        <h2 className="admin-news-detail-heading mb-4">
          {isNew ? "Nueva noticia" : "Editar noticia"}
          {noticia.slug && (
            <small className="ms-3 text-muted" style={{ fontSize: "0.5em" }}>
              slug: <code>{noticia.slug}</code>
            </small>
          )}
        </h2>

        {/* Image */}
        <MDBRow className="mb-4">
          <MDBCol size="12" className="text-center">
            <label className="form-label fw-bold d-block mb-2">
              Imagen de cabecera
            </label>
            <div className="admin-news-img-wrapper">
              <MfmImageUploader
                uuid={noticia.imageUuid || null}
                appCode="MUGIN"
                library="noticias"
                size="medium"
                mediaType="image"
                mediaFormat="16/9"
                mediaFrameSize="320x180"
                allowPicker
                onUpload={(result) =>
                  this.updateField("imageUuid", result.uuid)
                }
                onDelete={() => this.updateField("imageUuid", null)}
                style={{ width: "100%", aspectRatio: "16/9", borderRadius: 8 }}
              />
            </div>
          </MDBCol>
        </MDBRow>

        {/* Title */}
        <MDBRow className="mb-3">
          <MDBCol size="12">
            <MDBInput
              type="text"
              label="Título"
              value={noticia.titulo || ""}
              onChange={(e) => this.updateField("titulo", e.target.value)}
            />
          </MDBCol>
        </MDBRow>

        {/* Short text */}
        <MDBRow className="mb-3">
          <MDBCol size="12">
            <MDBInput
              type="textarea"
              label="Texto corto (resumen para tarjetas)"
              value={noticia.textoCorto || ""}
              onChange={(e) => this.updateField("textoCorto", e.target.value)}
              rows={3}
            />
          </MDBCol>
        </MDBRow>

        {/* Full text — Rich Text Editor */}
        <MDBRow className="mb-3">
          <MDBCol size="12">
            <label className="form-label fw-bold d-block mb-2">
              Cuerpo de la noticia
            </label>
            <RichTextEditor
              initialHtml={noticia.texto || ""}
              onChangeHtml={(html) => this.updateField("texto", html)}
              height={300}
              appCode="MUGIN"
            />
          </MDBCol>
        </MDBRow>

        {/* Date + Sort order */}
        <MDBRow className="mb-3">
          <MDBCol size="6">
            <MDBInput
              type="date"
              label="Fecha"
              value={noticia.fecha || ""}
              onChange={(e) => this.updateField("fecha", e.target.value)}
            />
          </MDBCol>
          <MDBCol size="3">
            <MDBInput
              type="number"
              label="Orden"
              step="any"
              value={noticia.sortOrder ?? 0}
              onChange={(e) =>
                this.updateField("sortOrder", parseFloat(e.target.value) || 0)
              }
            />
          </MDBCol>
          <MDBCol size="3" className="d-flex align-items-center">
            <MDBSwitch
              id="admin-news-active"
              label="Activa"
              checked={this.isActive()}
              onChange={(e) =>
                this.updateField("active", e.target.checked ? 1 : 0)
              }
            />
          </MDBCol>
        </MDBRow>

        {/* External link */}
        <MDBRow className="mb-3">
          <MDBCol size="12">
            <MDBInput
              type="text"
              label="Enlace externo (opcional)"
              value={noticia.link || ""}
              onChange={(e) => this.updateField("link", e.target.value)}
            />
          </MDBCol>
        </MDBRow>

        {/* Action buttons */}
        <div className="admin-news-detail-actions">
          <MDBBtn color="success" onClick={this.handleSave}>
            <MDBIcon icon="save" className="me-2" />
            Guardar
          </MDBBtn>

          <MDBBtn
            className="ms-2 mugin-btn-primary"
            onClick={this.handleNewNoticia}
          >
            <MDBIcon icon="plus" className="me-2" />
            Nueva noticia
          </MDBBtn>

          {noticiaId && (
            <MDBBtn
              color="danger"
              outline
              className="ms-2"
              onClick={() => this.setState({ showDeleteConfirm: true })}
            >
              <MDBIcon icon="trash" className="me-2" />
              Eliminar
            </MDBBtn>
          )}
        </div>

        {showDeleteConfirm && (
          <PopConfirm
            show={showDeleteConfirm}
            title="Confirmar eliminación"
            detail="¿Está seguro de que desea eliminar esta noticia? Esta acción no se puede deshacer."
            onConfirm={this.handleDelete}
            onCancel={() => this.setState({ showDeleteConfirm: false })}
          />
        )}
      </div>
    );
  }
}
